import React from 'react'
import AddAlbumContainer from '../../modules/OrganizationAlbums/containers/AddAlbumContainer/AddAlbumContainer'

export default function AddAlbum() {
  return (
    <AddAlbumContainer />
  )
}
